import React from 'react';
import Routes from './routes';
import '@picocss/pico/scss/pico.scss';
import { useDocumentTitle } from './hooks/title';

const App = () => {

  useDocumentTitle("Marriott Unified Platform Helper");

  return (
    <div>
      {Routes()}
    </div>
  );
};

export default App;
